// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compliance {
  margin-left: 14%;
  margin-top: 30px;
}

.compliance .back-btn {
  border: none;
  background-color: transparent;
  padding-bottom: 10px;
}

.compliance .back-btn i {
  color: #0981fd;
  font-size: 16px;
}

.compliance .status {
  padding: 10px 15px;
  border: none;
  margin-bottom: 8px;
}

.compliance .pending-message {
  background-color: #d071004b;
  color: #a05700;
}

.compliance .success-message {
  background-color: #dbffed;
  color: #006a35;
}

.compliance .failed-message {
  background-color: #ffdbda;
  color: #ff0700;
}

.compliance .bordered-row {
  border-right: 2px solid #cccaca;
  margin-bottom: 20px;
}

.compliance h4 {
  text-align: left;
  letter-spacing: 0px;
  color: #7e7e7e;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 100;
  margin-top: 10px;
  margin-bottom: 5px;
}

.compliance .data-info {
  margin-bottom: 10px;
  color: #002277;
  font-size: 12px;
  font-weight: 500;
}

.compliance .actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 40px;
}

.compliance .actions .btn {
  border: none;
  color: #ffffff;
  font-size: 12px;
  padding: 10px 15px;
  box-shadow: none;
}

.compliance .actions .approve-btn {
  background-color: #265f48;
}

.compliance .actions .decline-btn {
  background-color: #de0000;
}

.compliance .pending-btn {
  background-color: #ffcf96;
  border: none;
  color: #a05700;
  padding: 5px 0px;
  border-radius: 6px;
  width: 70px;
}

.compliance .declined-status {
  background-color: #ffdbda;
  border: none;
  color: #ff0700;
  padding: 5px 0px;
  border-radius: 6px;
  width: 70px;
}

.compliance .approved-status {
  background-color: #dbffed;
  border: none;
  color: #006a35;
  padding: 5px 0px;
  border-radius: 6px;
  width: 70px;
}

.compliance .uploaded-document img {
  height: 250px;
}

.compliance .grouped-input {
  background-color: #ffffff;
  border: 0.5px solid #48484833;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/compliance/Compliance.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB","sourcesContent":[".compliance {\n  margin-left: 14%;\n  margin-top: 30px;\n}\n\n.compliance .back-btn {\n  border: none;\n  background-color: transparent;\n  padding-bottom: 10px;\n}\n\n.compliance .back-btn i {\n  color: #0981fd;\n  font-size: 16px;\n}\n\n.compliance .status {\n  padding: 10px 15px;\n  border: none;\n  margin-bottom: 8px;\n}\n\n.compliance .pending-message {\n  background-color: #d071004b;\n  color: #a05700;\n}\n\n.compliance .success-message {\n  background-color: #dbffed;\n  color: #006a35;\n}\n\n.compliance .failed-message {\n  background-color: #ffdbda;\n  color: #ff0700;\n}\n\n.compliance .bordered-row {\n  border-right: 2px solid #cccaca;\n  margin-bottom: 20px;\n}\n\n.compliance h4 {\n  text-align: left;\n  letter-spacing: 0px;\n  color: #7e7e7e;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 100;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.compliance .data-info {\n  margin-bottom: 10px;\n  color: #002277;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.compliance .actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 40px;\n}\n\n.compliance .actions .btn {\n  border: none;\n  color: #ffffff;\n  font-size: 12px;\n  padding: 10px 15px;\n  box-shadow: none;\n}\n\n.compliance .actions .approve-btn {\n  background-color: #265f48;\n}\n\n.compliance .actions .decline-btn {\n  background-color: #de0000;\n}\n\n.compliance .pending-btn {\n  background-color: #ffcf96;\n  border: none;\n  color: #a05700;\n  padding: 5px 0px;\n  border-radius: 6px;\n  width: 70px;\n}\n\n.compliance .declined-status {\n  background-color: #ffdbda;\n  border: none;\n  color: #ff0700;\n  padding: 5px 0px;\n  border-radius: 6px;\n  width: 70px;\n}\n\n.compliance .approved-status {\n  background-color: #dbffed;\n  border: none;\n  color: #006a35;\n  padding: 5px 0px;\n  border-radius: 6px;\n  width: 70px;\n}\n\n.compliance .uploaded-document img {\n  height: 250px;\n}\n\n.compliance .grouped-input {\n  background-color: #ffffff;\n  border: 0.5px solid #48484833;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
